import React, { Component } from 'react';
import GruposAfinidadSeleccionadasItem from './GruposAfinidadSeleccionadasItem';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

class  GruposAfinidadSeleccionadas extends Component {
    constructor(props) {
        super(props)

       this.showMoreBranches = this.showMoreBranches.bind(this);
       this.showLessBranches = this.showLessBranches.bind(this);
    }

    showMoreBranches() {
        this.props.showMoreBranches();
    }

    showLessBranches() {
        this.props.showLessBranches();
    }

    render() {
        let data = this.props.data.GET_GRUPO_AFINIDAD_ADMINISTRADORA.filter(x => x.Checked == true && x.Id != 0);
        let branchesManagerButton = null;

        if (data.length > 0) {
            if (data.length > 10){
                if (this.props.data.showMoreBranches == false) {
                    let originalDataSize = data.length;
                    data = data.slice(0, 10);
                    let moreBranchesText = "Ver todas (" + originalDataSize + ")...";
                    let moreBranches = <GenericSimpleButton buttonType="button" text={moreBranchesText} buttonClass="btn btn-link" onClick={this.showMoreBranches} />;
                    branchesManagerButton = moreBranches;
                } else {
                    let closeBranchesList = <GenericSimpleButton buttonType="button" text="Cerrar la lista" buttonClass="btn btn-link" onClick={this.showLessBranches} />;
                    branchesManagerButton = closeBranchesList;
                }
            }
        }

        if (data) {
            var selectedBranchesNodes = data.map((selectedBranch) => {
                return <GruposAfinidadSeleccionadasItem
                    key={selectedBranch.Id}
                    id={selectedBranch.Id}
                    descripcion={selectedBranch.Descripcion}
                    codigo={selectedBranch.Codigo}
                    composite={selectedBranch.Composite}
                    removeSelectedBranch={this.props.removeSelectedBranch}
                />
            })
        }
        return (
            data.length > 0 &&
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="no-bullets">
                            {selectedBranchesNodes}
                            {branchesManagerButton}
                        </ul>
                    </div>

                </div>
            </div>
        );
    }
};

export default GruposAfinidadSeleccionadas;